import log from 'salvo-lite/log'
class Video {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._video = elem.querySelector('video')
        this._trigger = elem.querySelector('[data-video-play]')
        log.debug(this.constructor.name, 'Constructed', this)
    }
    onInit () {
        this._trigger.addEventListener('click', e => {
            this._trigger.classList.add('visually-hidden')
            this._video.play()
        })
        this._video.addEventListener('ended', e => {
            this._trigger.classList.remove('visually-hidden')
        })
    }
}

export default Video



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Video.js